import React from 'react';
import {CardBody, Form, FormGroup, Input, Label, Modal, Row, Col} from "reactstrap";

const text_amount = (amount) => {
  return `$ ${(amount * 1).toFixed(2)}`
}

const render_rows = (tog_standard, modal_standard, onChangeInput, new_client_name, new_client_email) => {

  return (
    <Modal
      isOpen={modal_standard}
      toggle={() => tog_standard('client_name')}
    >
      <div className="modal-header">
        <h5 className="modal-title mt-0" id="myModalLabel">
          Descuento
        </h5>
        <button type="button"
                onClick={() => tog_standard('client_name')}
                className="close"
                data-dismiss="modal"
                aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div className="modal-body">
        <Form>
          <Row>
            <Col sm="12">
              <FormGroup>
                <Label htmlFor="bundle_qty">Nombre del cliente</Label>
                <Input autoComplete="off" type="text" className="form-control" defaultValue={new_client_name} onChange={ e => {onChangeInput(e.target.value, 'client_name')} }/>
              </FormGroup>
            </Col>
            <Col sm="12" className="mt-2">
              <FormGroup>
                <Label htmlFor="bundle_qty">E-mail del cliente</Label>
                <Input autoComplete="off" type="text" className="form-control" defaultValue={new_client_email} onChange={ e => {onChangeInput(e.target.value, 'client_email')} }/>
              </FormGroup>
            </Col>
          </Row>
        </Form>
      </div>
      <div className="modal-footer">
        <button
          type="button"
          onClick={() => onChangeInput(null, 'client_name_close')}
          className="btn btn-secondary waves-effect"
          data-dismiss="modal"
        >
          Cancelar
        </button>
        <button
          type="button"
          className="btn btn-primary waves-effect waves-light"
          style={{ backgroundColor: 'rgb(174,174,174)', borderColor: 'rgb(177,177,177)' }}
          onClick={() => onChangeInput(null, 'update_client_name')}
        >
          Aceptar
        </button>
      </div>
    </Modal>
  );
}

const ModalClientName= ({tog_standard, modal_standard, onChangeInput, new_client_name, new_client_email}) => (
  render_rows(tog_standard, modal_standard, onChangeInput, new_client_name, new_client_email)
)

export default ModalClientName
